import Divider from '@mui/material/Divider';
import AnalyticsFileTable from './AnalyticsFileTable';
import { getStore } from '../../Store'
const store = getStore();


const AnalyticsFiles = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")

    return (
        <div>
            <div style={{ fontSize: "40px" }}>{id} Analytics Files</div>
            <br/>
            <Divider/>
            <br/>
            <AnalyticsFileTable network_run_id={id} />
        </div>
    )
}

export default AnalyticsFiles;